module.exports = __webpack_public_path__ + "img/left-4.2dc3f311.jpg";